/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Training } from '../../models/training';
import { TrainingApiRespModel } from '../../models/training-api-resp-model';

export interface ApiMasterTrainingEditPost$Params {
      body?: Training
}

export function apiMasterTrainingEditPost(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingEditPost$Params, context?: HttpContext): Observable<StrictHttpResponse<TrainingApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingEditPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TrainingApiRespModel>;
    })
  );
}

apiMasterTrainingEditPost.PATH = '/api/Master/Training/Edit';
